function initObserver() {
  var scrollToViewPosition = function(){
     var categoryLeft_item = document.querySelectorAll('.category-left-list a');
        categoryLeft_item.forEach((elm, index) => {
            elm.addEventListener('click', (e) => {
                e.preventDefault();
                var dataId = elm.getAttribute('data-id');
                
                // Get the target element's bounding rectangle
                var targetElement = document.querySelector(`#${dataId}`);
                if (targetElement.classList.contains("hide_collection")) {
                  var elements = document.querySelectorAll('.category-list-item');

                  // Loop through the elements and remove the class
                  for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('hide_collection');
                  }
                  var loadMoreBtn = document.querySelector(".load-more-collections");
                  loadMoreBtn.style.display = "none";
                  initObserver();
                  // loadMoreBtn.click();
                }

                var rect = targetElement.getBoundingClientRect();
                // Calculate the target scroll position, leaving 100px from the top
                var targetScrollPosition = null;
  
                if (window.innerWidth < 750) {
                  targetScrollPosition = window.scrollY + rect.top - 50;
                }
                else{
                  targetScrollPosition = window.scrollY + rect.top;
                }

                // Scroll to the calculated position with an offset of 100px
                window.scrollTo({
                    top: targetScrollPosition,
                    behavior: 'smooth'
                });
            });
        });
  }

  scrollToViewPosition();
  document.addEventListener("resize", scrollToViewPosition);
  
    // Find all h2 elements within the content
    //const content = document.getElementById('content');
    const categoryLeft_item = document.querySelectorAll('.category-left-list a');
    const categoryRight_item = document.querySelectorAll('.category-list-item');

    // Get the headings and sections
    const headings = document.querySelectorAll('.category-left-list a');
    const sections = document.querySelectorAll('.category-list-item');

    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      var options = {
        threshold: 0.4
      };
    }else{
      var options = {
        threshold: 0.7
      };
    }
    

    // Create an IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Find the index of the intersecting section
          const index = Array.from(sections).indexOf(entry.target);
          console.log('Entry',index);
          // Remove 'active' class from all headings
          headings.forEach(h => h.classList.remove('active'));
    
          // Add 'active' class to the corresponding heading
          headings[index].classList.add('active');
        }
      });
    }, options); // Adjust threshold as needed
    
    // Observe each section
    sections.forEach(section => {
      observer.observe(section);
    });
}

document.addEventListener("DOMContentLoaded", () => {
  initObserver();
});

// Learn More Button on Collection Page
 document.addEventListener("DOMContentLoaded", function () {
  // const loadMoreButton = document.querySelector(".load-more-collections");
  // const hiddenSections = document.querySelectorAll(".hide_collection");
  // let currentSectionIndex = 0;

  // loadMoreButton.addEventListener("click", function () {
  //   if (currentSectionIndex < hiddenSections.length) {
  //     hiddenSections[currentSectionIndex].style.display = "block";
  //     currentSectionIndex++;
  //   }

  //   // Hide the "Load more" button when all sections are shown
  //   if (currentSectionIndex === hiddenSections.length) {
  //     loadMoreButton.style.display = "none";
  //   }
  // });
});
